'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.makeLine = makeLine;

function makeLine(arr, bool) {

  var chart = new Highcharts.Chart({
    chart: {
      renderTo: 'main',
      type: 'spline',
      height: window.innerHeight - 180,
      width: window.innerWidth * 0.96
    },
    title: {
      text: ''
    },
    subtitle: {
      text: 'Source USDA, www.fas.usda.gov/gats',
      x: -20
    },
    xAxis: {
      title: {
        text: 'Year'
      },
      categories: [1999, 2000, 2001, 2002, 2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014]
    },
    yAxis: {
      min: 0,
      title: {
        text: 'Million $'
      },
      plotLines: [{
        value: 0,
        width: 1,
        color: '#808080'
      }]
    },
    tooltip: {
      crosshairs: true,
      //shared: true//,
      // headerFormat: "{point.x}: {point.category}",
      // pointFormat: "<b>{point.y:.1f} Million$<b>"
      formatter: function formatter() {
        return "<b>" + this.x + " <b>" + this.series.name + ":<br/>" + this.y + " Million$";
      }
    },
    legend: {
      enabled: bool,
      layout: 'vertical',
      align: 'right',
      verticalAlign: 'middle',
      borderWidth: 0,
      symbolHeight: 10
    },
    plotOptions: {
      spline: {
        lineWidth: 2,
        states: {
          hover: {
            lineWidth: 8
          }
        },
        marker: {
          enabled: false
        }
      }
    },
    series: arr
  });
}
//# sourceMappingURL=data:application/json;base64,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